const auctidRegexDescription = '(?:\\[(AUCTID)])|(?:\\${(AUCTID)})|(?:%5B(AUCTID)%5D)|(?:%24%7B(AUCTID)%7D)';
const AuctidMacroRegex = new RegExp(`(${auctidRegexDescription})`, 'gi');

export const addEnhancedAttributionMacroValue = (destination_url: string, value?: string): string => {
  if (destination_url.includes(disableAddingAuctidKeyword)) {
    return removeDisableAddingAuctidKeyword(destination_url);
  }

  const auctid = value || '00000000-0000-0000-0000-000000000000';
  if (destination_url.includes('ad.doubleclick.net')) {
    const queryParameterIdx = destination_url.indexOf('?http');
    if (queryParameterIdx >= 0) {
      const finalUrl = destination_url.substring(queryParameterIdx + 1);
      return destination_url.substring(0, queryParameterIdx) + '?' + appendAuctId(finalUrl, auctid);
    }
    return destination_url.replace(AuctidMacroRegex, auctid);
  } else if (destination_url.includes('bs.serving-sys.com') || destination_url.includes('track.adform.net')) {
    return destination_url.replace(AuctidMacroRegex, auctid);
  }

  return appendAuctId(destination_url, auctid);
};

function removeDisableAddingAuctidKeyword(url: string): string {
  const index = url.indexOf(disableAddingAuctidKeyword);
  if (url.includes('?' + disableAddingAuctidKeyword + '&')) {
    // leave ? and remove &
    return url.slice(0, index) + url.slice(index + disableAddingAuctidKeyword.length + 1);
  } else if (['?', '&'].includes(url[index - 1])) {
    // remove ? or & before param
    return url.slice(0, index - 1) + url.slice(index + disableAddingAuctidKeyword.length);
  }

  return url.slice(0, index) + url.slice(index + disableAddingAuctidKeyword.length);
}

function appendAuctId(url: string, auctid: string): string {
  const urlWithAuctid = new URL(url);

  // To handle a specific case where query parameters are not formatted with the key=value structure,
  // we need to skip this step when the auctid is already set in the url.
  if (!urlWithAuctid.searchParams.get('auctid')) {
    urlWithAuctid.searchParams.set('auctid', auctid);
  }

  return urlWithAuctid.toString().replace(AuctidMacroRegex, auctid);
}

const disableAddingAuctidKeyword = 'teads_auctid=false';
